// Largo máximo de los campos de texto que comparten los ABM de programa-salud.
//
// Cada límite vive en DOS lugares por formulario y tienen que decir lo mismo:
//
//   1. `maxLength` del input — impide seguir escribiendo. Es la defensa real: el
//      usuario nunca llega a pasarse.
//   2. `.max()` de yup — avisa al enviar. Cubre lo que no pasa por el teclado: un
//      valor precargado desde el back, un pegado, un autocompletado del navegador.
//
// Si los dos se desincronizan, el input deja escribir de más y el error recién
// aparece al guardar. Por eso el número vive acá y no repetido en cada modal.

export const LARGO = {
    nombre: 45,
    cod: 20,
    desc: 150,
};

/**
 * Mensaje de las reglas de yup.
 *
 * Dice "no puede superar" y no "menos de N": `.max(45)` ACEPTA 45 caracteres, así que
 * el texto anterior ("Debe tener menos de 45 caracteres") contradecía a la validación
 * justo en el borde.
 */
export const mensajeLargo = (largo) =>
    `No puede superar los ${largo} caracteres`;
